import { useSelector } from 'react-redux';
import { selectFeatureFlags } from '@reducers/user';
import { selectSelectedChartDate, selectSelectedChartDateEnd, selectSelectedTimeCounter } from '@reducers/machinesV2';
import { selectSelectedItem, selectUpdatedMachineEventsTimelineHash } from '@reducers/machines';
import { selectIsWithERP } from '@reducers/membership';
import { Machine } from '@interfaces/machines';

export const useTimelineSelectors = () => {
  const featureFlags = useSelector(selectFeatureFlags);
  const selectedChartDate = useSelector(selectSelectedChartDate);
  const selectedChartDateEnd = useSelector(selectSelectedChartDateEnd);
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const selectedTimeCounter = useSelector(selectSelectedTimeCounter);
  const updatedMachineEventsTimelineHash = useSelector(selectUpdatedMachineEventsTimelineHash);
  const isWithERP = useSelector(selectIsWithERP);

  return { featureFlags, selectedChartDate, selectedChartDateEnd, selectedMachine, selectedTimeCounter, updatedMachineEventsTimelineHash, isWithERP };
};
